import classnames from 'classnames'

import { MobileTab } from 'modules/transmission/types'
import InformationTab from 'modules/chat/components/informationTab/informationTab'
import { useTransmissionContext } from 'modules/transmission/context'
import ChatContainer from 'modules/chat/containers/chat'

import './tabManager.scss'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'

export interface Props {
  mediaCode?: string
}

const TabManager = ({ mediaCode }: Props) => {
  const { activeTab } = useTransmissionContext()

  // TODO: Add schedule page content
  const renderContent: {[tab in MobileTab]: JSX.Element | null } = {
    [MobileTab.COUNTER]: null,
    [MobileTab.LANGUAGE]: null,
    [MobileTab.INFORMATION]: <InformationTab/>,
    [MobileTab.CHAT]: <ChatContainer mediaCode={mediaCode} />,
    [MobileTab.SCHEDULE]: null
  }

  return (
    <>
      {Object.keys(renderContent).map(key => {
        const tab = key as MobileTab

        return (
          <div
            className={classnames('tab-manager-item', { '_d-none': tab !== activeTab })}
            key={tab}
            data-test={`container-${key}`}>
            {renderContent[tab]}
          </div>
        )
      })}
    </>
  )
}

export default TabManager
